// new Aleksei
import { useQuery } from '@tanstack/react-query';
import supabase from 'sdk/api';

const getStoreById = async (id: string) => {
    const { data, error } = await supabase
        .from('store_owners_profile')
        .select(`*, country(*)`)
        .eq('id', id)
        .single();

    if (error) {
        throw new Error(error.message);
    }

    return data;
};

const useGetStoreById = (id: string) => {
    return useQuery({
        queryKey: ['store', id],
        queryFn: () => getStoreById(id),
        enabled: !!id,
    });
};

export default useGetStoreById;